import $ from 'jquery';

/**
 * @return {void}
 */
export function matchTeaserHeights() {
  const $elTeaserGroups = $('[data-mh-group="teaser"]');
  $elTeaserGroups.each((index, element) => {
    const $el = $(element);

    $el.find('.teaser__picture').matchHeight();
    $el.find('.teaser__tags').matchHeight();
    $el.find('.teaser__header').matchHeight();
    $el.find('.teaser__excerpt').matchHeight();
    $el.find('.teaser__content-wrapper').matchHeight();
    $el.find('.teaser').matchHeight();
  });
}

/**
 * @return {void}
 */
export function matchSliderHeights() {
  const sliderEntries = $('.slider');

  setTimeout(() => {
    const flickitySlider = $('.flickity-slider');

    flickitySlider.each((index, element) => {
      const $el = $(element);

      $el.find('.teaser__picture').matchHeight();
      $el.find('.teaser__tags').matchHeight();
      $el.find('.teaser__header').matchHeight();
      $el.find('.teaser__excerpt').matchHeight();
      $el.find('.teaser__content-wrapper').matchHeight();
      $el.find('.teaser').matchHeight();
    });
  }, 2000);

  /**
   * @param  {JQuery} slider Slider
   * @return {void}
   */
  function setArrowPostion(slider) {
    const sliderTeaser = $(slider).find('.teaser__picture');
    const sliderArrow = $(slider).find('.flickity-prev-next-button');
    const sliderTeaserHeight = sliderTeaser.height();
    const positionTop = ((sliderTeaserHeight / 2));

    sliderArrow.css('top', positionTop);
  }

  /**
   * @return {void}
   */
  function setArrowPostionForAllSliders() {
    sliderEntries.each((i, slider) => {
      setArrowPostion(slider);
    });
  }

  setArrowPostionForAllSliders();
  $.fn.matchHeight._afterUpdate = () => { // eslint-disable-line no-underscore-dangle
    setArrowPostionForAllSliders();
  };
}



// WEBPACK FOOTER //
// ./assets/js/components/match-height.js